import UserIcon from '../../assets/icons/user.svg?react'
import Skeleton from '../Loaders/Skeleton'
import css from './avatar.module.css'
import { CSSProperties, MouseEvent, ReactNode } from 'react'
import useAvatarCtrl from './useAvatarCtrl'
import { IAvatar, IUser } from '@/pages/Users/users.types'

interface IProps {
  initials?: string | ReactNode
  userId?: IUser['id']
  fileName?: IAvatar['fileName']
  onClick?: (ev: MouseEvent<HTMLDivElement>) => void
  size: 'large' | 'default' | 'small'
  online?: boolean
  wrapperStyle?: CSSProperties
  skeletonStyle?: CSSProperties
  loading?: boolean
}

const Avatar = ({ online = false, ...props }: IProps) => {
  const ctrl = useAvatarCtrl(props.userId, props.fileName)

  const renderContent = () => {
    if (props.loading) {
      return renderSkeleton()
    }

    if (props.userId && props.fileName && !ctrl.error) {
      return (
        <>
          <img
            src={ctrl.url}
            alt="Аватар"
            style={{ opacity: !ctrl.loading && ctrl.url ? 1 : 0 }}
            className={css.avatarImage}
          />
          {ctrl.loading && renderSkeleton()}
        </>
      )
    }

    if (props.initials) {
      if (typeof props.initials === 'string') return <h3 className="text-caption text-white">{props.initials}</h3>
      return props.initials
    }

    return <UserIcon data-size={props.size} className={css.icon} />
  }

  const renderSkeleton = () => {
    return (
      <Skeleton
        height="100%"
        width="100%"
        style={{ borderRadius: '50%', position: 'absolute', top: 0, left: 0, ...props.skeletonStyle }}
      />
    )
  }

  return (
    <div
      className={css.wrapper}
      data-size={props.size}
      data-pressable={Boolean(props.onClick)}
      data-content-type={props.userId && !ctrl.error ? 'image' : 'initials'}
      onClick={props.onClick}
      style={props.wrapperStyle ?? {}}
    >
      {online && <div className={css.onlineIcon} data-size={props.size} />}
      {renderContent()}
    </div>
  )
}

export default Avatar
